import {
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Button,
  Spinner,
  Col,
  Modal,
  ModalBody,
  Input,
  Label,
  Form,
} from "reactstrap";
// core components
import OnlyHeader from "components/Headers/OnlyHeader.js";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { getWalletTransaction } from "store/actions/walletAction";
import moment from "moment";
import { getTotalAmount } from "store/actions/walletAction";
import { CSVLink } from "react-csv";
import { withdrawRequest } from "store/actions/walletAction";
import { toUpWalletAmount } from "store/actions/walletAction";
import { toast } from "react-toastify";
import { cashbackData } from "store/actions/walletAction";
import Paypal from "components/Paypal";
import firebase from "../config/firebase";
import { getOnlyWalletTransaction } from "store/actions/walletAction";
import { getOtherWalletTransaction } from "store/actions/walletAction";
import { checkSchoolContract } from "store/actions/walletAction";
import cross from "../assets/img/custom/cross.svg";
import { submitContractRequest } from "store/actions/contractAction";
import { refreshAuth } from "store/actions/authAction";

const WalletTransactions = ({ ...args }) => {
  let dispatch = useDispatch();
  const csvLink = useRef(null);
  let auth = useSelector((state) => state.auth);

  let {
    walletTransaction,
    walletMoreData,
    walletLastDocument,
    totalWalletAmount,
    otherTransaction,
    otherMoreData,
    otherLastDocument,
  } = useSelector((state) => state.wallet);
  const [filter, setFilter] = useState("");
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const [dataLoader, setLoader] = useState(true);
  const [withdrawModal, setWithdrawModal] = useState(false);
  const [withdrawLoader, setWithdrawLoader] = useState(false);
  const [withdrawAmount, setWithdrawAmount] = useState("");
  const [topUpModal, setTopUpModal] = useState(false);
  const [topUpLoader, setTopUpLoader] = useState(false);
  const [topUpAmount, setTopUpAmount] = useState("");
  const [showPaypal, setShowPaypal] = useState(false);
  const [activeAmount, setActiveAmount] = useState("ip");
  const [isSchoolContract, setIsSchoolContract] = useState(true);
  useEffect(() => {
    if (activeAmount === "top-up") {
      setFilteredTransactions(walletTransaction);
    } else if (activeAmount === "ip") {
      setFilteredTransactions(otherTransaction);
    }
    // setFilteredTransactions(walletTransaction);
  }, [walletTransaction, otherTransaction, activeAmount]);
  useEffect(() => {
    if (activeAmount === "top-up") {
      if (!walletTransaction || walletTransaction?.length == 0) {
        setLoader(true);
        dispatch(
          getOnlyWalletTransaction(
            auth.user.role == "school-sub-admin"
              ? auth.user.school_admin_id
              : auth.uid,
            "",
            () => {
              setLoader(false);
            }
          )
        );
      }
    } else if (activeAmount === "ip") {
      if (!otherTransaction || otherTransaction?.length == 0) {
        setLoader(true);
        dispatch(
          getOtherWalletTransaction(
            auth.user.role == "school-sub-admin"
              ? auth.user.school_admin_id
              : auth.uid,
            "",
            () => {
              setLoader(false);
            }
          )
        );
      }
    }
    // dispatch(
    //   getWalletTransaction(auth.uid, "", () => {
    //     setLoader(false);
    //   })
    // );
  }, [activeAmount]);
  const [isContractSigned, setIsContractSigned] = useState(false);
  const [isContractSignedLoader, setIsContractSignedLoader] = useState(true);
  useEffect(() => {
    dispatch(refreshAuth(auth.uid));
    dispatch(
      getTotalAmount(
        auth.user.role == "school-sub-admin"
          ? auth.user.school_admin_id
          : auth.uid
      )
    );
    dispatch(
      checkSchoolContract(auth.user.email, (res) => {
        if (res === "empty" || res.status !== "approved") {
          setActiveAmount("top-up");
          setIsSchoolContract(true);
          if (res?.status == "signed") {
            setIsContractSigned(true);
          } else {
            setIsContractSigned(false);
          }
        } else {
          setIsSchoolContract(false);
        }
        setIsContractSignedLoader(false);
      })
    );
  }, []);
  const [btnLoader, setBtnLoader] = useState(false);
  const handleWithdraw = (e) => {
    e.preventDefault();
    setWithdrawModal(!withdrawModal);
    setWithdrawAmount("");
  };
  const handleTopUp = () => {
    setTopUpModal(!topUpModal);
    setTopUpAmount("");
    setShowPaypal(false);
  };
  const handleTopUpAmount = () => {
    setTopUpLoader(true);
    let data = {
      amount: Number(topUpAmount),
      userId: auth.uid,
    };
  };
  const handleWithdrawAmount = (e) => {
    e.preventDefault();
    setWithdrawLoader(true);
    let data = {
      amount: withdrawAmount,
      userId: auth.uid,
    };
    if (withdrawAmount == "") {
      toast.error("Please add amount");
      setWithdrawLoader(false);
    } else {
      dispatch(
        withdrawRequest(data, () => {
          setWithdrawLoader(false);
          setWithdrawAmount("");
          setWithdrawModal(false);
        })
      );
    }
  };
  const handleFilter = (e) => {
    const selectedFilter = e.target.value;
    setFilter(selectedFilter);
    if (selectedFilter === "") {
      if (activeAmount === "top-up") {
        setFilteredTransactions(walletTransaction);
      } else if (activeAmount === "ip") {
        setFilteredTransactions(otherTransaction);
      }
    } else {
      const filteredTransaction = walletTransaction.filter(
        (item) => item.data.serviceType === selectedFilter
      );
      setFilteredTransactions(filteredTransaction);
    }
  };

  const loadMore = () => {
    setBtnLoader(true);
    if (activeAmount === "top-up") {
      dispatch(
        getOnlyWalletTransaction(auth.uid, walletLastDocument, () => {
          setLoader(false);
        })
      );
    } else if (activeAmount === "ip") {
      dispatch(
        getOtherWalletTransaction(auth.uid, otherLastDocument, () => {
          setLoader(false);
        })
      );
    }
    // dispatch(
    //   getWalletTransaction(auth.uid, lastDocument, () => {
    //     setBtnLoader(false);
    //   })
    // );
  };
  const getPaypalDetail = (data) => {
    let obj = {
      amount: data.purchase_units[0].amount.value,
      payment_id: data.id,
      createdAt: firebase.firestore.Timestamp.now(),
      paymentType: "wallet",
      serviceType: "top up",
      userId:
        auth.user.role == "school-sub-admin"
          ? auth.user.school_admin_id
          : auth.uid,
      fhpAdminAmount: topUpAmount * 0.045,
      schoolAmount: topUpAmount * (1 - 0.045),
    };
    dispatch(
      toUpWalletAmount(obj, auth.user.email, () => {
        setTopUpLoader(false);
        setTopUpModal(false);
      })
    );
  };
  const headers = [
    { label: "Type", key: "type" },
    { label: "Amount", key: "amount" },
    { label: "Day", key: "day" },
    { label: "Athlete Email", key: "athleteEmail" },
    { label: "Total Amount", key: "totalAmount" },
  ];
  const [request, setRequest] = useState({
    modal: false,
    loader: false,
    imageURL: "",
    Licensor: {
      Address: "",
      City: "",
      LicensorEmail: "",
      LicensorName: "",
      LicensorSignature: "",
      Zip: "",
    },
    School: {
      Address: "",
      City: "",
      Ext: "",
      Phone: "",
      SVOFirstName: "",
      SVOLastName: "",
      Zip: "",
    },
  });

  const handleChangeLicensor = (e) => {
    let { name, value } = e.target;
    setRequest((prev) => ({
      ...prev,
      Licensor: {
        ...prev.Licensor,
        [name]: value,
      },
    }));
  };
  const handleChangeSchool = (e) => {
    let { name, value } = e.target;
    setRequest((prev) => ({
      ...prev,
      School: {
        ...prev.School,
        [name]: value,
      },
    }));
  };

  const toggleRequestModal = () => {
    setRequest((prev) => ({
      ...prev,
      modal: !prev.modal,
    }));
  };

  const handleRequestSubmit = (e) => {
    e.preventDefault();
    setRequest((prev) => ({
      ...prev,
      loader: true,
    }));
    let { modal, loader, ...prevData } = request;
    let newData = {
      ...prevData,
      acceptedAt: new firebase.firestore.Timestamp(
        auth.user.created_at.seconds,
        0
      ),
      approvedAT: new firebase.firestore.Timestamp(
        auth.user.created_at.seconds,
        0
      ),
      createdAt: firebase.firestore.Timestamp.now(),
      email: auth.user.email,
      country: auth.user.county,
      school: auth.user.instituteName,
      state: auth.user.state,
      type:
        auth.user.instituteLevel == "High School"
          ? "High School contract"
          : "College contract",
      status: "signed",
    };
    dispatch(
      submitContractRequest(newData, () => {
        setRequest((prev) => ({
          ...prev,
          modal: false,
          loader: false,
          imageURL: "",
          Licensor: {
            Address: "",
            City: "",
            LicensorEmail: "",
            LicensorName: "",
            LicensorSignature: "",
            Zip: "",
          },
          School: {
            Address: "",
            City: "",
            Ext: "",
            Phone: "",
            SVOFirstName: "",
            SVOLastName: "",
            Zip: "",
          },
        }));
        setIsContractSigned(true);
        toast.success("Send Request Successfully");
      })
    );
  };

  return (
    <>
      <OnlyHeader />
      {/* Page content */}
      <Container className="mt--7" fluid>
        <Row className="d-flex justify-content-center mb-4 ip_cards">
          <Col
            xs="12"
            sm="6"
            md="6"
            lg="4"
            className={`mb-2 ${
              ((auth.user?.type && auth.user?.type == "collective") ||
                (auth.user.role == "school-sub-admin" &&
                  auth.user.permissions_school_ip == false)) &&
              "d-none"
            }`}
          >
            <Card
              className={`p-4 text-center ${
                activeAmount == "ip" && !isSchoolContract
                  ? "bg-primary"
                  : "pointer"
              }`}
              onClick={() => {
                !isSchoolContract && setActiveAmount("ip");
              }}
            >
              {isContractSignedLoader ? (
                <div
                  className="d-flex justify-content-center
                align-items-center h-100"
                >
                  <Spinner color="primary" />
                </div>
              ) : isSchoolContract ? (
                <div
                  className="d-flex flex-column
                justify-content-center h-100
                "
                >
                  {" "}
                  <h2>
                    {isContractSigned
                      ? "Wait for admin approved"
                      : "Request For Contract"}{" "}
                  </h2>
                  <div className={isContractSigned && "d-none"}>
                    <Button
                      color="primary"
                      size="sm"
                      onClick={toggleRequestModal}
                    >
                      <div className="tooltip-container">
                        Request
                        <span className="tooltip-text">
                          THE IP CONTRACT YOU SIGN HERE WILL HELP YOUR ATHLETES
                          MONETIZE THEIR BRANDS
                        </span>
                      </div>
                    </Button>
                  </div>
                </div>
              ) : (
                <>
                  <h2 className={` ${activeAmount == "ip" && "text-white"}`}>
                    Ip Amount{" "}
                    <h1
                      className={` ${
                        activeAmount == "ip" ? "text-white" : "text-primary"
                      }`}
                    >
                      {totalWalletAmount?.amount
                        ? totalWalletAmount?.amount
                        : 0}
                      $
                    </h1>
                  </h2>
                  <div>
                    <Button
                      color={activeAmount == "ip" ? "white" : "primary"}
                      size="sm"
                      onClick={handleWithdraw}
                    >
                      withdraw
                    </Button>
                  </div>
                </>
              )}
            </Card>
          </Col>
          <Col xs="12" sm="6" md="6" lg="4" className="mb-2">
            <Card
              className={`p-4 text-center ${
                activeAmount == "top-up" ? "bg-primary" : "pointer"
              }`}
              onClick={() => setActiveAmount("top-up")}
            >
              <h2 className={` ${activeAmount == "top-up" && "text-white"}`}>
                Top up Amount{" "}
                <h1
                  className={` ${
                    activeAmount == "top-up" ? "text-white" : "text-primary"
                  }`}
                >
                  {totalWalletAmount && totalWalletAmount?.topupAmount
                    ? totalWalletAmount?.topupAmount - 0.5
                    : 0}
                  $
                </h1>
              </h2>
              <div>
                <Button
                  color={activeAmount == "top-up" ? "white" : "primary"}
                  size="sm"
                  onClick={handleTopUp}
                >
                  Top up
                </Button>
              </div>
            </Card>
          </Col>
        </Row>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between align-items-center flex-sm-row flex-column gap-3">
                <h3 className="mb-0 text-left WalletHeaderHeading">Wallet</h3>
                <div className="d-flex justify-content-center align-items-center mt-3 mt-sm-0 WalletHeaderActions">
                  <select
                    className="form-control mr-2"
                    value={filter}
                    onChange={handleFilter}
                  >
                    <option value="">-- Select type --</option>
                    <option value="momento">Momento</option>
                    <option value="seasonal badges">Badges</option>
                    <option value="group chat">Chat</option>
                  </select>
                  <CSVLink
                    ref={csvLink}
                    headers={headers}
                    filename={`Chat ${moment(new Date()).format(
                      "DD-MM-YYYY"
                    )}.csv`}
                    data={
                      filteredTransactions == -1
                        ? []
                        : filteredTransactions.map((item) => {
                            return {
                              ...item,
                              type: item.data.serviceType,
                              amount: item.data.amount + "$",
                              day: moment
                                .unix(item.data.createdAt.seconds)
                                .format("DD-MM-YYYY"),
                              athleteEmail: item.athlete?.email,
                              totalAmount: totalWalletAmount + "$",
                            };
                          })
                    }
                    className="ml-auto btn btn-primary text-nowrap"
                  >
                    Export CSV
                  </CSVLink>
                </div>
              </CardHeader>
              {dataLoader ? (
                <div className="text-center">
                  {" "}
                  <Spinner color="primary" size="md" />
                </div>
              ) : (
                <>
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">Type</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Day</th>
                        <th scope="col">Athlete email</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredTransactions.length > 0 ? (
                        filteredTransactions.map((items, index) => {
                          return (
                            <tr key={index}>
                              <td>{items.data.paymentType}</td>
                              <td>{items.data.amount}$</td>
                              <td>
                                {" "}
                                {moment
                                  .unix(items.data.createdAt.seconds)
                                  .format("MMM-DD-YYYY")}
                              </td>
                              <td>{items.athlete.email}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  {filteredTransactions.length > 1 && (
                    <div className="text-center mb-2">
                      <Button
                        color="primary"
                        onClick={loadMore}
                        disabled={
                          (activeAmount == "ip"
                            ? !otherMoreData
                            : !walletMoreData) || btnLoader
                        }
                      >
                        {btnLoader ? <Spinner size="sm" /> : "Load more"}
                      </Button>
                    </div>
                  )}
                </>
              )}
            </Card>
          </div>
        </Row>
      </Container>
      <Modal isOpen={withdrawModal} toggle={handleWithdraw} size="sm">
        <ModalBody>
          <Form onSubmit={handleWithdrawAmount}>
            <div>
              <label htmlFor="">Enter the amount you wish to withdraw:</label>
              <Input
                type="number"
                placeholder="Enter amount (min: $25)"
                onChange={(e) => setWithdrawAmount(Number(e.target.value))}
                min={25}
                value={withdrawAmount}
                required
              />
              <small className="text-danger">
                Note: Withdrawal must be at least $25
              </small>
            </div>
            <div className="text-right mt-4">
              <Button size="sm" onClick={handleWithdraw}>
                Cancel
              </Button>
              <Button color="primary" size="sm" type="submit">
                {withdrawLoader ? <Spinner size="sm" /> : "Withdraw"}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
      <Modal isOpen={topUpModal} toggle={handleTopUp} size="sm">
        <ModalBody>
          <div>
            <label htmlFor="">Enter the amount you wish to top up:</label>
            <Input
              placeholder="Enter amount"
              onChange={(e) => setTopUpAmount(Number(e.target.value))}
              value={topUpAmount}
              disabled={showPaypal}
              type="number"
              min={1000}
            />
          </div>
          <div className="text-center py-4">
            {showPaypal ? (
              <Paypal
                price={topUpAmount + 0.5}
                getPaypalDetail={getPaypalDetail}
              />
            ) : (
              <Button
                color="primary"
                size="sm"
                onClick={() => {
                  topUpAmount < 1000
                    ? toast.warning("Minimum top-up amount is 1000")
                    : setShowPaypal(true);
                }}
              >
                {topUpLoader ? <Spinner size="sm" /> : "Top up"}
              </Button>
            )}
          </div>
          <div className="text-right mt-4">
            <Button size="sm" color="danger" onClick={handleTopUp}>
              Cancel
            </Button>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={request.modal} toggle={toggleRequestModal} size="xl">
        <ModalBody>
          <Form onSubmit={handleRequestSubmit}>
            <h1>Contract Data</h1>
            <div className="col-sm-4 d-flex flex-column align-items-start mx-auto">
              <Label className="auth-label mt-4">Upload ID</Label>
              <Input
                type="file"
                required
                name="player_img"
                accept="image/png, image/gif, image/jpeg"
                onChange={(e) =>
                  setRequest((prev) => ({
                    ...prev,
                    imageURL: e.target.files[0],
                  }))
                }
              />
              {request.imageURL && (
                <div className="position-relative mt-3">
                  <img
                    src={URL?.createObjectURL(request.imageURL)}
                    alt=""
                    className=" mt-2"
                    width={80}
                    height={80}
                  />
                  <img
                    src={cross}
                    width={20}
                    alt=""
                    className="position-absolute"
                    style={{
                      top: "-11%",
                      left: "80%",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      setRequest((prev) => ({
                        ...prev,
                        imageURL: "",
                      }))
                    }
                  />
                </div>
              )}
            </div>
            <hr />
            <div>
              <Label className="mt-5 auth-label">
                Address Where School Located
              </Label>
              <br />
              <div className="d-sm-flex">
                <div className="col-sm-4">
                  <Label className="auth-label mt-3">State</Label>
                  <Input
                    id="auto-complete"
                    autoComplete
                    includeInputInList
                    value={auth.user?.state}
                    disabled
                    required
                  />
                </div>
                <div className="col-sm-4">
                  <Label className="auth-label mt-3">
                    {auth.user.instituteLevel == "High School"
                      ? "Country"
                      : "City"}
                  </Label>
                  <Input
                    id="auto-complete-college"
                    autoComplete
                    includeInputInList
                    value={auth.user.county}
                    disabled
                    required
                  />
                </div>
                <div className="col-sm-4">
                  <Label className="auth-label mt-3">School</Label>
                  <Input
                    id="auto-complete-school"
                    autoComplete
                    includeInputInList
                    value={auth.user.instituteName}
                    disabled
                    required
                  />{" "}
                </div>
              </div>
              <h1 className="text-center my-4 text-underline bold">
                LICENSE AGREEMENT
              </h1>
              <p className="d-inlin ContractInputBox">
                This License Agreement{" "}
                <strong className="bold"> (“Agreement”)</strong> is made and
                entered as of{" "}
                <Input
                  className="d-inline ContractInputBox"
                  type="text"
                  style={{ maxWidth: "100px", marginLeft: "5px" }}
                  value={new Date().toLocaleDateString()}
                  disabled
                  required
                />
                {"  "}
                <strong className="bold">(“Effective Date”) </strong> , by and
                between FansHelpPlayers, LLC
                <strong className="bold"> (“FHP”)</strong> and{" "}
                <strong className="bold">(“Licensor”) </strong> , each being
                referred to individually as a{" "}
                <strong className="bold"> “Party,” </strong>and collectively as
                the
                <strong className="bold"> “Parties” </strong>throughout this
                Agreement.
              </p>
              <p>
                <span className="bold"> WHEREAS,</span> FHP operates an online
                platform that allows athletes to register an account{" "}
                <span className="bold"> (“FHP Brand Ambassadors”)</span> for the
                purpose of producing products and engaging with fans (the{" "}
                <span className="bold"> “Platform”</span>);
              </p>
              <p>
                <span className="bold"> WHEREAS,</span> the Platform allows FHP
                Brand Ambassadors to create a digital compilation of
                athletics-related photos, text, and linked videos known as{" "}
                <span className="bold"> “FHP Mementos”</span> that can be
                purchased by fans utilizing the Platform;
              </p>
              <p className="mb-0 ">
                <span className="bold"> WHEREAS,</span> Licensor is the owner of
                the IP Rights (as later defined) for the following
                school/university:
                <Input
                  className="d-inline  "
                  type="text"
                  style={{ maxWidth: "340px", marginLeft: "5px" }}
                  value={auth.user.instituteName}
                  disabled
                  required
                />
                {"  "}
                (the <span className="bold"> “School”</span>);
              </p>
              <p className="">and</p>
              <p>
                <span className="bold"> WHEREAS,</span> the Parties wish to set
                forth the terms and conditions pursuant to which FHP shall
                compensate Licensor in exchange for Licensor’s grant of a
                license in and to the IP Rights to FHP and/or FHP Brand
                Ambassadors for use in FHP Mementos and/or otherwise in
                promotion of the Platform.
              </p>
              <p>
                <span className="bold"> NOW, THEREFORE,</span> in consideration
                of the mutual promises and conditions contained in this
                Agreement, and for other good and valuable consideration, the
                receipt of which is hereby acknowledged, the Parties agree as
                follows:
              </p>
              <h2 className="text-center text-underline  ">
                TERMS AND CONDITIONS
              </h2>
              <ul className=" px-3 text-justify">
                <li className="my-2">
                  <strong className="text-underline">
                    {" "}
                    Adoption of Recitals.
                  </strong>{" "}
                  The above recitations are true and correct and are
                  incorporated herein by this reference. The Parties hereby
                  cancel and revoke all prior agreements between them relating
                  to the subject matter of this Agreement, whether oral or
                  written.
                </li>
                <li className="my-2">
                  <strong className="text-underline"> Term. </strong>The term of
                  this Agreement shall commence on the Effective Date, and shall
                  remain in full force and effect for a period of 5 years{" "}
                  <span className="bold"> (“Term”).</span>
                </li>
                <li className="my-2">
                  <strong className="text-underline"> Grant of License.</strong>{" "}
                  During the Term, Licensor grants FHP the non-exclusive,
                  worldwide, royalty-free (except as otherwise provided for
                  herein), sublicensable right and license to use Licensor’s IP
                  Rights in connection with: (i) FHP and/or any FHP Brand
                  Ambassadors creation, development, design, advertisement,
                  promotion, offering and selling of FHP Mementos, including,
                  without limitation, via the Platform, and (ii) the promotion
                  of Licensor’s relationship with FHP and/or FHP Brand
                  Ambassadors (the <span className="bold"> “License”</span>
                  ). Without limiting any of the foregoing, Licensor agrees that
                  FHP (or one of its affiliates) and/or FHP Brand Ambassador(s)
                  may use the IP Rights in connection with the manufacturing,
                  marketing, sale, and distribution of FHP Mementos via the
                  Platform or for use (royalty free) in FHP’s general marketing
                  or internal use. Licensor further acknowledges that for any
                  FHP Memento created during the Term utilizing Licensor’s IP
                  Rights, Licensor's IP Rights included in such FHP Memento may
                  be sold or utilized solely as contained therein in perpetuity,
                  but Licensor’s IP Rights may not be used in connection with
                  the creation of new and/or subsequent versions of FHP Mementos
                  following the expiration and/or termination of this Agreement.
                  For the purpose of this Agreement,{" "}
                  <span className="bold"> “IP Rights”</span> means Licensor’s
                  trademarks, trade names, corporate names, team names, logos,
                  service marks, brand indicia, videos and/or other electronic
                  media (including, but not limited to game footage),
                  copyrights, School uniforms, School-sponsored sports
                  activities appearances, School-sponsored venue appearances,
                  and all other intellectual property and/or proprietary
                  materials that together constitute the brand image and/or
                  language by which the School is known to the general public,
                  including, without limitation, the School-specific IP Rights
                  set forth in <span className="bold"> Schedules A and B</span>,
                  attached hereto.
                </li>
                <li className="my-2">
                  <strong className="text-underline"> Compensation. </strong>
                  In exchange for the License granted herein, FHP agrees to
                  compensate Licensor in accordance with the terms set forth in{" "}
                  <span className="bold"> Schedule A (“Compensation”).</span>
                </li>
                <li className="my-2">
                  <strong className="text-underline">
                    {" "}
                    Ownership of FHP Mementos.
                  </strong>{" "}
                  Licensor agrees and acknowledges that all FHP Mementos shall
                  be created as original files owned by FHP, and Licensor
                  acknowledges that all FHP Mementos shall solely and
                  exclusively be owned by FHP in perpetuity and throughout the
                  world (subject to the terms and conditions regarding purchases
                  of FHP Mementos made via the Platform). In furtherance
                  thereof, Licensor shall not have, nor lay claim to, any
                  rights, title, or interest in and to any FHP Mementos created
                  in accordance with the terms set forth in this Agreement. All
                  ownership rights, title, and interest in and to the FHP
                  Mementos, and any and all derivative works made therefrom,
                  will be, become, and remain the sole property of FHP during
                  and after the Term. FHP and FHP Brand Ambassadors shall have
                  the sole right to set the price for, and collect the proceeds
                  from, the sale of any FHP Mementos.
                </li>
                <li className="my-2">
                  <strong className="text-underline"> Termination.</strong>{" "}
                  Either Party may elect to terminate this Agreement immediately
                  upon written notice to the other Party as follows:
                  <ul>
                    <li className="my-2">
                      <strong className="text-underline">
                        {" "}
                        Material Breach:
                      </strong>{" "}
                      A Party materially breaches any representation, warranty
                      provision, duty, obligation, or covenant in this Agreement
                      or refuses to fulfill any material obligation under this
                      Agreement and such Party fails to cure such breach within
                      thirty (30) days of receiving notice of such breach.
                    </li>
                    <li className="my-2">
                      <strong className="text-underline">
                        {" "}
                        Mutual Termination:
                      </strong>{" "}
                      This Agreement may be terminated upon the mutual written
                      consent of the Parties.{" "}
                    </li>
                  </ul>
                </li>
                <li className="my-2">
                  <strong className="text-underline">
                    {" "}
                    Non-Disparagement.
                  </strong>
                  Licensor agrees that at no time during or after the Term will
                  Licensor disparage FHP or FHP’s goods and services, including,
                  but not limited to, the Platform.
                </li>
                <li className="my-2">
                  <p>
                    <strong className="text-underline bold">
                      {" "}
                      Confidentiality.
                    </strong>{" "}
                    The Parties acknowledge and agree that the terms of this
                    Agreement, and any and all confidential information
                    regarding a Party or its operations that is disclosed by a
                    Party to the other in furtherance of this Agreement,
                    including, without limitation, information concerning the
                    Parties’ operating and marketing methods, pricing practices,
                    and sales figures, and any other information deemed
                    proprietary by the disclosing Party
                    <span className="text-center">
                      {" "}
                      (“Confidential Information”)
                    </span>{" "}
                    will be treated as confidential and will not be disclosed to
                    any third party (except as set forth herein) at any time
                    during the Term of this Agreement and thereafter or used for
                    any purposes other than for purposes contemplated by this
                    Agreement, such contemplated use including sharing relevant
                    terms of this agreement with FHP Brand Ambassadors in
                    association with their work of compiling FHP mementos and/or
                    prospective Brand Ambassadors and advisors.
                  </p>
                  <p>
                    Each Party agrees to: (i) protect the other Party’s
                    Confidential Information using the same standard of care it
                    uses to protect its own Confidential Information, provided
                    that in no event will a Party use less than a reasonable
                    standard of care; and (ii) not disclose the other Party’s
                    Confidential Information, except to its affiliates,
                    contractors, employees, independent contractors, and agents
                    who express a “need to know” and have agreed in writing or
                    are otherwise under a legal duty to keep such information
                    confidential at a level no less protective than required
                    herein. Each Party (and any affiliates, contractors,
                    employees and agents to whom it has disclosed Confidential
                    Information) may use the other Party’s Confidential
                    Information only to the extent necessary to exercise the
                    rights granted and fulfill its duties and obligations
                    contained within this Agreement, and each Party acknowledges
                    that it shall be responsible for the actions of any of its
                    affiliates, partners, contractors, employees, and agents
                    that are in violation hereof. All Confidential Information
                    shall be the exclusive property of the disclosing Party and
                    shall be returned to the disclosing Party, or destroyed,
                    immediately upon the termination or expiration of this
                    Agreement, or at any other time at the disclosing Party’s
                    request.
                  </p>
                  <p>
                    Each Party may disclose the other Party’s Confidential
                    Information when required by law but only to the extent
                    necessary to comply with such law and only after such Party,
                    if legally permissible: (i) uses commercially reasonable
                    efforts to notify the other Party; and (ii) gives the other
                    Party the chance to challenge or limit the disclosure.
                  </p>
                </li>
                <li className="my-2">
                  <p>
                    <strong className="text-underline bold">
                      {" "}
                      Representations and Warranties.
                    </strong>{" "}
                    Each Party represents, warrants, and covenants to the other
                    Party that it has the full right and power to (i) enter into
                    this Agreement, (ii) perform all obligations to be performed
                    by it hereunder, and (iii) grant all rights hereunder
                    granted, in each case without violating the legal or
                    equitable rights of any other person or entity.
                  </p>
                  <p>
                    Licensor further represents and warrants that, as of the
                    Effective Date and continuing throughout the Term of this
                    Agreement, (i) Licensor has all necessary rights and/or
                    permission to grant the License to FHP in accordance with
                    the terms of this Agreement; and (ii) FHP’s use of the IP
                    Rights will not: (a) infringe the rights of any third party;
                    (b) require the payment by FHP of any royalties,
                    remuneration, residuals or any other fees (except as
                    otherwise expressly set forth herein); or (c) result in any
                    tort, injury, damage or harm to any third party.
                  </p>
                </li>
                <li className="my-2">
                  <strong className="text-underline"> Indemnification.</strong>{" "}
                  Licensor shall defend, indemnify and hold harmless FHP, and
                  FHP’s officers, directors, employees, representatives, and
                  members, (collectively,{" "}
                  <span className="bold"> “FHP Indemnitees”</span>), from and
                  against any and all claims, suits, losses, damages and
                  expenses (including reasonable attorney’s fees and expenses),
                  resulting from third party claims made or suits brought
                  against any FHP Indemnitee to the extent based on any action
                  or omissions by or on behalf of Licensor, including, without
                  limitation, those based upon: (i) Licensor’s grant of the
                  License; (ii) FHP’s use of the IP Rights in accordance with
                  the terms set forth in this Agreement; (iii) any negligent
                  act, error or omission, or willful misconduct of Licensor, or
                  any third party acting for or on behalf of Licensor; and/or
                  (iv) Licensor’s breach of any term, condition, representation,
                  or warranty contained in this Agreement (each a{" "}
                  <span className="bold"> “Claim”</span>). If any Claim is
                  brought against an FHP Indemnitee, Licensor will defend such
                  Claim at Licensor’s sole expense using counsel selected by the
                  FHP Indemnitee. If Licensor fails to take timely action to
                  defend such Claim, the FHP Indemnitee may defend such Claim at
                  Licensor’s expense, including, without limitation, deduction
                  of any Compensation payable under this Agreement. Licensor
                  shall cooperate in all reasonable respects with the
                  investigation, disclosure and defense of any Claim. Licensor
                  will not settle, compromise or otherwise enter into any
                  agreement regarding the disposition of any Claim against an
                  FHP Indemnitee without the prior written consent and approval
                  of the FHP Indemnitee.
                </li>
                <li className="my-2">
                  <strong className="text-underline">
                    {" "}
                    Limitation of Liability.{" "}
                  </strong>
                  Notwithstanding Licensor’s duty to indemnify FHP in accordance
                  with Section 10 of this Agreement, in no event shall either
                  Party be liable to the other Party for any special, exemplary,
                  indirect, incidental, consequential, or punitive damages of
                  any kind or nature whatsoever (including, without limitation,
                  lost revenue, profits, savings, or business), whether in an
                  action based on contract, warranty, strict liability, tort
                  (including, without limitation, negligence) or otherwise, even
                  if such Party has been informed in advance of the possibility
                  of such damages, or if such damages could have reasonably been
                  foreseen by such Party. In no event will FHP’s liability under
                  this Agreement exceed the total amount of Compensation paid by
                  FHP to Licensor in the six (6) months preceding the act that
                  gave rise to liability.
                </li>
                <li className="my-2">
                  <strong className="text-underline"> Waiver. </strong>The
                  failure of either Party to exercise the rights granted to such
                  Party under this Agreement upon the occurrence of any of the
                  contingencies set forth in this Agreement shall not in any
                  event constitute a waiver of any such rights upon the
                  occurrence of any additional such contingencies.
                </li>
                <li className="my-2">
                  <strong className="text-underline"> Notices.</strong> Any
                  notice required to be given hereunder shall be given by
                  sending the same by email, overnight express mail or
                  registered or certified mail, postage prepaid, return receipt
                  requested to the address stated herein, or to any subsequent
                  address designated by either Party for the purpose of
                  receiving notices pursuant to this Agreement. All notices
                  shall be deemed validly given: (i) after one (1) business day
                  if sent via email or overnight express mail, or (ii) after
                  five (5) business days if sent via registered or certified
                  mail. Notices shall be sent to the following:
                  <div className="row d-flex justify-content-cente mt-5 ">
                    <div className="col-sm-3">If to FHP:</div>
                    <div className="col-sm-3">
                      <p className="m-0">128 DORCHESTER F</p>
                      <p className="m-0"> WEST PALM BEACH, FL 33417</p>
                      <p className="m-0">Email: fanshelpplayers@gmail.com</p>
                    </div>
                  </div>
                  <div className="row d-flex justify-content-cente mt-5 ">
                    <div className="col-sm-3">If to Licensor:</div>
                    <div className="col-sm-3">
                      <Input
                        className="d-inline mb-2"
                        type="text"
                        placeholder="Address"
                        name="Address"
                        value={request.Licensor.Address}
                        onChange={handleChangeLicensor}
                        required
                      />
                      <Input
                        className="d-inline mb-2"
                        type="text"
                        placeholder="City"
                        name="City"
                        value={request.Licensor.City}
                        onChange={handleChangeLicensor}
                        required
                      />
                      <Input
                        className="d-inline mb-2"
                        type="number"
                        placeholder="Zip code"
                        name="Zip"
                        value={request.Licensor.Zip}
                        onChange={handleChangeLicensor}
                        required
                      />
                      <div>
                        Email:{" "}
                        <Input
                          className="d-inline mb-4"
                          type="email"
                          name="LicensorEmail"
                          value={request.Licensor.LicensorEmail}
                          onChange={handleChangeLicensor}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </li>
                <li className="my-2">
                  <strong className="text-underline">
                    {" "}
                    Press Release; Promotion.
                  </strong>{" "}
                  The Parties may, upon mutual agreement, issue a press release
                  upon execution of this Agreement or issue other public
                  marketing and communications materials during the Term
                  detailing and/or promoting the business arrangement hereunder.
                </li>
                <li className="my-2">
                  <strong className="text-underline"> Severability.</strong> In
                  the event any provision of this Agreement is determined to be
                  invalid by a court of competent jurisdiction, such
                  determination shall in no way affect the validity or
                  enforceability of any other provision contained herein.
                </li>
                <li className="my-2">
                  <strong className="text-underline">
                    {" "}
                    Governing Law; Dispute Resolution.
                  </strong>{" "}
                  This Agreement shall be governed by and construed in
                  accordance with the laws of the State of Florida, without
                  regard to conflict of law principles thereof. Each Party
                  agrees that binding arbitration under the Commercial Rules of
                  Arbitration of the American Arbitration Association before a
                  single arbitrator shall resolve any dispute or controversy
                  arising in connection with this Agreement. Any such
                  arbitration shall be conducted in Broward County, Florida.
                  Judgment upon any award may be entered in any court of
                  competent jurisdiction. The decision of the arbitrator shall
                  be binding and conclusive upon the Parties. In the event of
                  any legal action or arbitration proceeding brought for the
                  enforcement of this Agreement, the prevailing party shall be
                  entitled to recover reasonably incurred attorney’s fees and
                  costs. Notwithstanding, this agreement to binding arbitration
                  shall not prevent either Party from seeking injunctive and/or
                  other equitable relief from a court of competent jurisdiction
                  located in Broward County, Florida.
                </li>
                <li className="my-2">
                  <strong className="text-underline">
                    {" "}
                    Relationship of the Parties.
                  </strong>{" "}
                  The Parties agree that nothing herein shall be deemed to
                  constitute either Party as a partner, employee, joint venture,
                  or agent of the other Party. Neither Party shall have the
                  power or authority to bind the other with respect to third
                  parties or to represent to third parties that they have such
                  authority. Licensor expressly acknowledges and agrees that FHP
                  will not withhold any federal, state or local income or
                  unemployment insurance or social security taxes from any
                  payments made under this Agreement (except where tax
                  withholding is otherwise required by law), and that it is the
                  responsibility of Licensor to report and pay all income,
                  unemployment insurance, social security and other taxes on
                  Licensor’s own behalf.
                </li>
                <li className="my-2">
                  <strong className="text-underline">
                    {" "}
                    No Third-Party Beneficiaries.{" "}
                  </strong>
                  Nothing contained herein, expressed or implied, is intended or
                  shall be construed to confer upon or give to any person or
                  entity, other than the Parties to this Agreement and their
                  respective successors and permitted assigns, any rights or
                  remedies under or by reason of this Agreement. This Agreement,
                  and all provisions and conditions hereof, are intended to be,
                  and shall be, for the sole and exclusive benefit of the
                  Parties and their respective successors and permitted assigns,
                  and not for the benefit of any other person or entity.
                </li>
                <li className="my-2">
                  <strong className="text-underline"> Assignment.</strong> This
                  Agreement and any rights or obligations of Licensor hereunder
                  shall not be assigned or delegated, whether by transfer,
                  merger, operation of law or otherwise, without FHP’s prior
                  written consent. FHP may assign and/or sublicense its rights
                  hereunder to any affiliate or successor entity in the event of
                  a merger, reorganization or sale of FHP or substantially all
                  of its assets. All provisions of this Agreement are binding
                  upon, shall inure to the benefit of, and are enforceable by or
                  against the Parties and their respective heirs, executors,
                  administrators or other legal representatives and permitted
                  successors and assigns.
                </li>
                <li className="my-2">
                  <strong className="text-underline"> Entire Agreement.</strong>{" "}
                  This Agreement and schedules attached hereto constitute the
                  entire understanding between the Parties with respect to the
                  subject matter of this Agreement and supersedes all prior
                  agreements whether written or oral. No waiver, modification or
                  addition to this Agreement shall be valid unless made in
                  writing and signed by the Parties hereto. This Agreement may
                  be executed concurrently in one or more counterparts, each of
                  which shall be an original, but all of which together shall
                  constitute one and the same instrument. This Agreement shall
                  not be binding upon either Party until executed by an
                  authorized officer thereof.
                </li>
              </ul>
              <p>
                <strong className="bold"> IN WITNESS WHEREOF</strong>, the
                Parties have duly executed this Agreement as of the Effective
                Date written above.
              </p>
              <div className="row d-flex justify-content-center mt-5 ">
                <div className="col-sm-6">
                  <h2 className="text-center mb-4">LICENSOR</h2>
                  By:{" "}
                  <Input
                    className="d-inline mb-2"
                    type="text"
                    name="LicensorSignature"
                    value={request.Licensor.LicensorSignature}
                    onChange={handleChangeLicensor}
                    required
                  />
                  <div>
                    Name:{" "}
                    <Input
                      className="d-inline mb-2"
                      type="text"
                      name="LicensorName"
                      value={request.Licensor.LicensorName}
                      onChange={handleChangeLicensor}
                      required
                    />
                  </div>
                  <p>I have authority to bind Licensor</p>
                </div>
                <div className="col-sm-6">
                  <h2 className="text-center mb-4">FANSHELPPLAYERS, LLC</h2>
                  By:{" "}
                  <Input
                    className="d-inline mb-2"
                    type="text"
                    disabled
                    // value={Contract?.FHPAdmin?.Name}
                    required
                  />
                  <div>
                    Name:{" "}
                    <Input
                      className="d-inline mb-2"
                      type="text"
                      disabled
                      // value={Contract?.FHPAdmin?.Signature}
                      required
                    />
                  </div>
                  <p>I have authority to bind FHP</p>
                </div>
              </div>
              <div>
                <h2 className="text-center bold text-underline">Schedule A</h2>
                <p className="bold">School-specific IP Rights:</p>
                <p>[Description/List of IP Rights].</p>
                <p>
                  All IP Rights licensed under this Agreement shall be linked to
                  the applicable FHP Brand Ambassador on the Platform. FHP shall
                  provide each FHP Brand Ambassador and/or his/her advisor with
                  written verification of such FHP Brand Ambassador’s ability to
                  utilize the IP Rights solely in connection with FHP Mementos.
                </p>
                <p className="bold">Usage Guidelines:</p>
                <p>
                  Licensor acknowledges that the License grants FHP at least the
                  following usage rights:
                </p>
                <ul>
                  <li className="my-2">
                    School’s name can appear in text, in photos, and in linked
                    videos of FHP Mementos
                  </li>
                  <li className="my-2">
                    An FHP Brand Ambassador participating in athletics at the
                    School may appear in his/her School’s athletic uniform in
                    FHP Mementos
                  </li>
                  <li className="my-2">
                    Permissible views of the School’s athletic events (i.e.
                    footage) can be included in FHP Mementos. The list of
                    permissible vs. restricted views is set forth in{" "}
                    <span className="bold"> Schedule B.</span>
                  </li>
                </ul>
                <p className="bold">Compensation:</p>
                <p>
                  FHP shall pay Licensor [10%] of gross proceeds (
                  <span className="bold"> “Royalty”</span>) from the sale of
                  Licensed Products. “
                  <span className="bold"> Licensed Products</span>” means FHP
                  Mementos bearing Licensor’s IP Rights. Upon execution of the
                  Agreement, a Platform wallet will be established by FHP for
                  Licensor to show the amount of Royalty earned by Licensor
                  during the applicable payment period. Royalty payments shall
                  be paid on an annual basis via check payable to School name
                  and mailed to Licensor’s payment address provided to FHP;
                  provided, no payment shall be made in the event such annual
                  amount is less than $250, such lesser amounts continuing to
                  accrue in the wallet. FHP shall keep record of all royalties
                  associated to purchases of Licensed Products, which records
                  may be reviewed by Licensor at any time mutually agreeable to
                  the parties.
                </p>
              </div>
              <div>
                <h1 className="bold text-underline text-center">Schedule B</h1>
                {/* <h3 className="bold text-center">
                  APPENDIX - IP Rights Contract - CID#{" "}
                  <Input
                    className="d-inline ContractInputBox "
                    type="text"
                    // value={Contract?.cid}
                    disabled
                    style={{ maxWidth: "100px", marginLeft: "5px" }}
                    required
                  />
                </h3> */}
                <div className="row mt-4 mb-2 d-flex justify-content-center">
                  <div className="col-sm-4 mb-1">
                    <Label>School Name:</Label>
                    <Input
                      className="d-inline ContractInputBox "
                      type="text"
                      value={auth.user.instituteName}
                      disabled
                      required
                    />
                  </div>
                  <div className="col-sm-4 mb-1">
                    <Label>Address:</Label>
                    <Input
                      className="d-inline ContractInputBox "
                      type="text"
                      name="Address"
                      value={request.School.Address}
                      onChange={handleChangeSchool}
                      required
                    />
                  </div>
                  <div className="col-sm-4 mb-1">
                    <Label>City:</Label>
                    <Input
                      className="d-inline ContractInputBox "
                      type="text"
                      name="City"
                      value={request.School.City}
                      onChange={handleChangeSchool}
                      required
                    />
                  </div>
                  <div className="col-sm-4 mt-sm-2 mb-1">
                    <Label>State:</Label>
                    <Input
                      className="d-inline ContractInputBox "
                      type="text"
                      value={auth.user.state}
                      disabled
                      required
                    />
                  </div>
                  <div className="col-sm-4 mt-sm-2 mb-1">
                    <Label>Zip:</Label>
                    <Input
                      className="d-inline ContractInputBox "
                      type="number"
                      name="Zip"
                      value={request.School.Zip}
                      onChange={handleChangeSchool}
                      required
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <h3 className="text-underline mt-4">VIEWS ALLOWED</h3>
                    <p className="m-0">
                      Athletic training/practice at schoo, if invited by staff
                    </p>
                    <p className="m-0">
                      School Athletic event/rally, open to public or news media
                    </p>
                    <p className="m-0">
                      Competition in School sponsored Games/meets/matches
                    </p>
                    <p className="m-0">
                      {" "}
                      School athletic dorm room of athlete registered at FHP
                    </p>
                    <p className="m-0">
                      Locker room if invited by staff and no view unclothed
                      person
                    </p>
                    <p className="m-0">
                      School sports training rooms if by invitation of staff
                    </p>
                    <p className="m-0">
                      School sports cafeteria if by invitation of staff
                    </p>
                    <p className="m-0">
                      School sports office/meeting areas if by invitation of
                      staff
                    </p>
                    <p className="m-0">
                      Bthletes in school athletics uniform during good behavior
                    </p>
                    <p className="m-0">
                      School name/team name, f without disparaging context
                    </p>
                    <p className="m-0">
                      School stadium/eym in non-disparaging appropriate use
                    </p>
                    <p className="m-0">
                      Team meeting/team during travel, if by invitation of staff
                    </p>
                  </div>
                  <div className="col-sm-6">
                    <h3 className="text-underline mt-4">
                      RESTRICTED FROM VIEW
                    </h3>
                    <p className="m-0">Inappropriate behavior</p>
                    <p className="m-0">Inappropriate language or symbol</p>
                    <p className="m-0">Disparagement of school </p>
                    <p className="m-0"> Unclothed athlete or shower activity</p>
                    <p className="m-0">Closed meeting </p>
                    <p className="m-0">Non-public area without permission </p>
                    <p className="m-0">
                      School athlete in inappropriate off-campus venue{" "}
                    </p>
                    <p className="m-0">
                      School athlete in inappropriate off-campus activity{" "}
                    </p>
                    <p className="m-0">Closed practice </p>
                    <p className="m-0">
                      eam meeting or travel if not invited by staff{" "}
                    </p>
                  </div>
                </div>
                <div className="row my-3">
                  <div className="col-sm-4 mt-4">
                    SCHOOL VERIFICATION OFFICER(SVO)
                  </div>
                  <div className="col-sm-4 ">
                    First Name{" "}
                    <Input
                      className=" "
                      type="text"
                      name="SVOFirstName"
                      value={request.School.SVOFirstName}
                      onChange={handleChangeSchool}
                      required
                    />
                  </div>
                  <div className="col-sm-4 ">
                    Last Name{" "}
                    <Input
                      className=""
                      type="text"
                      name="SVOLastName"
                      value={request.School.SVOLastName}
                      onChange={handleChangeSchool}
                      required
                    />
                  </div>
                </div>
                <p className="d-sm-flex">
                  <span className="mt-2 mr-2">
                    Phone (must be # from school phone network):
                  </span>
                  <div className="contract-input">
                    <Input
                      type="number"
                      name="Phone"
                      value={request.School.Phone}
                      onChange={handleChangeSchool}
                      required
                    />
                  </div>{" "}
                  <span className="mt-2 mx-2">Ext :</span>
                  <div className="contract-input">
                    <Input
                      type="text"
                      name="Ext"
                      value={request.School.Ext}
                      onChange={handleChangeSchool}
                      required
                    />
                  </div>{" "}
                </p>
                <p className="d-sm-flex mb-3">
                  <span className="mt-2  mr-2">
                    SVO Email address(must be address in school email domain ) :
                  </span>
                  <div className="contract-input">
                    <Input
                      type="email"
                      value={auth.user?.email}
                      disabled
                      required
                    />
                  </div>
                </p>
              </div>
            </div>
            <div className="my-4 text-right">
              <Button color="danger" onClick={toggleRequestModal}>
                Cancel
              </Button>
              <Button color="primary" type="submit" disabled={request.loader}>
                {request.loader ? <Spinner size="sm" /> : "Submit"}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default WalletTransactions;
